export var SHADES_SIZE = 35;
export var SHADE_CLEAR_ICON_SIZE = '19px';
export var SHADES_SMALL_SIZE = 14;
export var SHADE_CLEAR_ICON_SMALL_SIZE = '10px';
export var WHITE_COLORS = ['white', '#fff', '#FFF', '#ffff', '#FFFF', '#ffffff', '#FFFFFF'];
//# sourceMappingURL=constants.js.map